import { render, staticRenderFns } from "./DataInputBoolean.vue?vue&type=template&id=db2d9a0c&scoped=true&"
import script from "./DataInputBoolean.vue?vue&type=script&lang=js&"
export * from "./DataInputBoolean.vue?vue&type=script&lang=js&"
import style0 from "./DataInputBoolean.vue?vue&type=style&index=0&id=db2d9a0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2d9a0c",
  null
  
)

export default component.exports